import React, { useState } from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/burger22.png";
import { BsFillPlayCircleFill } from "react-icons/bs";
import MenuImage1 from "../Assets/menu.jpg";
import Modal from "./Modal";

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Array of menu images
  const menuImages = [MenuImage1];

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="about-section-container App">
      <div className="about-background-image-container">
        <img src={AboutBackground} alt="About Background" />
      </div>
      <div className="about-section-image-container">
        <img
          style={{ width: "60rem" }}
          src={AboutBackgroundImage}
          alt="About"
        />
      </div>
      <div className="about-section-text-container">
        <p className="primary-subheading">About</p>
        <h1 className="primary-heading">
          Food Is An Important Part Of A Balanced Diet
        </h1>
        <p className="primary-text">
          At our cafe, we specialize in American smashed patties, crispy fried
          chicken burgers, and authentic Lebanese shawarmas. Our chefs ensure
          every dish is prepared with the freshest ingredients to deliver a
          delightful culinary experience.
        </p>
        <p className="primary-text">
          From savory burgers to flavorful shawarmas, our diverse menu caters to
          all tastes. We pride ourselves on quality and taste, making sure every
          meal is a satisfying one.
        </p>
        <div className="about-buttons-container">
          <button className="secondary-button" onClick={openModal}>
            Learn More
          </button>
          <button className="watch-video-button">
            <BsFillPlayCircleFill /> Watch Video
          </button>
        </div>
      </div>

      {/* Modal Implementation */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2>Our Menu</h2>
        <div className="menu-images-container">
          {menuImages.map((image, index) => (
            <img key={index} src={image} alt={`Menu ${index + 1}`} />
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default About;
